import HiringProcessBody from "components/ChallengeComponents/ChallengeDetailsComponents/HiringProcess/HiringProcessBody/HiringProcessBody";
import Header from "components/Common/Header/Header";
import React from "react";

const HiringProcess = () => {
  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="challenges" />

      {/* ---------- body section ------------- */}
      <HiringProcessBody />
    </main>
  );
};

export default HiringProcess;
